import { BackgroundCheckConfigByType } from '@/backend/features/background-check/defaults';
import { BackgroundCheckStatus } from '../../../types';

export function calculateBackgroundCheckStatus({
    backgroundCheckConfigForType,
    isConsentGiven = false,
}: {
    backgroundCheckConfigForType: BackgroundCheckConfigByType;
    isConsentGiven?: boolean;
}) {
    let backgroundCheckStatus: BackgroundCheckStatus = 'readyToSubmit';

    if (!backgroundCheckConfigForType?.enabled) {
        throw Error('Cannot calculate background check status');
    }

    const isManualBackgroundCheck = backgroundCheckConfigForType?.process === 'manual';

    if (!isConsentGiven && !isManualBackgroundCheck) {
        backgroundCheckStatus = 'didNotConsent';
    }

    return {
        status: backgroundCheckStatus,
        updatedAt: Date.now(),
    };
}
